const COUNTRY_GUIDE_CONTENT = [
    {
        id: 'background',
        title: 'backgroundTitle',
        description: 'backgroundContent',
        nav: {
            anchor: '#background',
            text: 'tocLinkBackground',
        },
    },
    {
        id: 'popular-destinations',
        title: 'popularDestinationsTitle',
        description: 'popularDestinationsContent',
        nav: {
            anchor: '#popular-destinations',
            text: 'tocLinkPopularDestinations',
        },
    },
    {
        id: 'scenic-routes',
        title: 'scenicRoutesTitle',
        description: 'scenicRoutesContent',
        nav: {
            anchor: '#scenic-routes',
            text: 'tocLinkScenicRoutes',
        },
    },
    {
        id: 'book-travel',
        title: 'bookTravelTitle',
        description: 'bookTravelContent',
        nav: {
            anchor: '#book-travel',
            text: 'tocLinkBookTravel',
        },
    },
    {
        id: 'finding-deals',
        title: 'findingDealsTitle',
        description: 'findingDealsContent',
        nav: {
            anchor: '#finding-deals',
            text: 'tocLinkFindingDeals',
        },
    },
    {
        id: 'passes',
        title: 'passesTitle',
        description: 'passesContent',
    },
    {
        id: 'services',
        title: 'servicesTitle',
        description: 'servicesContent',
        nav: {
            anchor: '#services',
            text: 'tocLinkServices',
        },
    },
    {
        id: 'getting-to-station',
        title: 'gettingToStationTitle',
        description: 'gettingToStationContent',
        nav: {
            anchor: '#getting-to-station',
            text: 'tocLinkGettingToStation',
        },
    },
    {
        id: 'getting-onboard',
        title: 'gettingOnboardTitle',
        description: 'gettingOnboardContent',
        nav: {
            anchor: '#getting-onboard',
            text: 'tocLinkGettingOnboard',
        },
    },
    {
        id: 'onboard-experience',
        title: 'onboardExperienceTitle',
        description: 'onboardExperienceContent',
        nav: {
            anchor: '#onboard-experience',
            text: 'tocLinkOnboardExperience',
        },
    },
    {
        id: 'pet-travel',
        title: 'petTravelTitle',
        description: 'petTravelContent',
        nav: {
            anchor: '#pet-travel',
            text: 'tocLinkPetTravel',
        },
    },
];

const TOC_NAV_ITEMS = {
    quickview: {
        anchor: '#quickview-title',
        text: 'tocLinkQuickview',
    },
    cityBlurb: {
        anchor: '#city-editorial-blurb',
        text: 'tocLinkAboutCity',
    },
    faq: {
        anchor: '#faq-header-section',
        text: 'tocLinkFaqs',
    },
    getAround: {
        anchor: '#get-around-section',
        text: 'tocLinkGetAround',
    },
    poi: {
        anchor: '#point-of-interest-section',
        text: 'tocLinkPois',
    },
    foreignTravel: {
        anchor: '#foreign-travel-section',
        text: 'tocLinkForeignTravel',
    },
    blog: {
        anchor: '#blog-section',
        text: 'tocLinkBlog',
    },
    app: {
        anchor: '#gta-intro-section',
        text: 'tocLinkApp',
    },
    abroad: {
        anchor: '#abroad-section',
        text: 'tocLinkForeignTravel',
    },
};

export {
    COUNTRY_GUIDE_CONTENT,
    TOC_NAV_ITEMS,
};
